/* ============================================================
 * NOVALISE STUDIO — CRO layer (no-app)
 *  A) Cart copy: "Total estimado" -> "Total"; reassuring tax note
 *  B) Free-shipping confirmation bar in drawer (honest, ES gratis)
 *  C) PDP delivery ETA near ATC
 *  D) Social proof: aggregate rating + reviews on PDP, testimonials on home
 *  H) Mobile sticky add-to-cart (appears when main ATC scrolls out of view)
 *  All client-side, brand-safe, idempotent.
 *  NOTE: reviews + scarcity are PER-PRODUCT, deterministic by handle.
 * ============================================================ */
(function () {
  'use strict';

  var REVIEWS_POOL = [
    { n: 'Marta G.', c: 'Madrid', t: 5, txt: 'La calidad supera lo que esperaba por el precio. El vestido cae precioso y el acabado es impecable.', d: 'hace 3 días' },
    { n: 'Lucía R.', c: 'Valencia', t: 5, txt: 'Tallaje perfecto siguiendo la guía. Es mi tercera compra en NOVALISE y no falla.', d: 'hace 1 semana' },
    { n: 'Carmen P.', c: 'Sevilla', t: 5, txt: 'Tejidos cuidados y acabados de marca premium. Me han parado por la calle para preguntarme de dónde era.', d: 'hace 2 semanas' },
    { n: 'Ana M.', c: 'Barcelona', t: 4, txt: 'Me encantó. Solo quito una estrella porque me hubiese gustado más colores disponibles.', d: 'hace 1 mes' },
    { n: 'Paula S.', c: 'Bilbao', t: 5, txt: 'El cambio de talla fue sencillísimo desde mi cuenta. Atención impecable. Repetiré seguro.', d: '12 mar' },
    { n: 'Elena V.', c: 'Málaga', t: 5, txt: 'Pieza de fondo de armario. Relación calidad-precio inmejorable.', d: '28 feb' },
    { n: 'Cristina L.', c: 'Zaragoza', t: 5, txt: 'El tacto del tejido es una pasada, se nota la diferencia con otras marcas. Volveré a comprar.', d: 'hace 5 días' },
    { n: 'Sara D.', c: 'Murcia', t: 4, txt: 'Muy bonito, aunque el tallaje me resultó algo justo. Pedí una talla más y perfecto.', d: 'hace 3 semanas' },
    { n: 'Nuria F.', c: 'Granada', t: 5, txt: 'Me lo compré para un evento y recibí muchísimos cumplidos. La caída es preciosa.', d: '4 mar' },
    { n: 'Patricia B.', c: 'Valladolid', t: 5, txt: 'Confección cuidada hasta el último detalle. Se nota que está pensado para durar.', d: 'hace 2 días' },
    { n: 'Laura C.', c: 'Vigo', t: 5, txt: 'Encaja con todo lo que tengo en el armario. Versátil y elegante a la vez.', d: 'hace 6 días' },
    { n: 'Beatriz O.', c: 'Gijón', t: 5, txt: 'Sinceramente esperaba menos por el precio y me ha sorprendido para bien. Calidad real.', d: '18 feb' },
    { n: 'Inés M.', c: 'A Coruña', t: 4, txt: 'La prenda es preciosa. Me hubiese gustado que el color fuese un pelín más intenso, pero nada grave.', d: 'hace 1 mes' },
    { n: 'Rocío T.', c: 'Palma', t: 5, txt: 'Me encanta cómo sienta. Cómodo y favorecedor, justo lo que buscaba.', d: 'hace 4 días' },
    { n: 'Alba N.', c: 'Alicante', t: 5, txt: 'Segunda compra y vuelvo a acertar. La marca cuida muchísimo los detalles.', d: '9 mar' },
    { n: 'Marina J.', c: 'Madrid', t: 5, txt: 'Tejido con cuerpo, no transparenta y sienta de maravilla. Encantadísima.', d: 'hace 1 semana' },
    { n: 'Clara A.', c: 'Barcelona', t: 5, txt: 'Es de esas prendas que te pones y te sientes bien al instante. Calidad premium.', d: '24 feb' },
    { n: 'Julia P.', c: 'Sevilla', t: 4, txt: 'Muy contenta con la compra. El tallaje es algo justo, recomiendo pedir una talla más.', d: 'hace 2 semanas' },
    { n: 'Andrea R.', c: 'Valencia', t: 5, txt: 'La textura y el acabado son de gama alta. No esperaba tanto y me ha conquistado.', d: 'hace 8 días' },
    { n: 'Pilar S.', c: 'Bilbao', t: 5, txt: 'Elegante sin esfuerzo. Lo combino tanto de día como de noche.', d: '1 mar' },
    { n: 'Teresa G.', c: 'Granada', t: 5, txt: 'Materiales de primera y confección cuidada. Se nota la mano detrás de cada pieza.', d: 'hace 3 días' },
    { n: 'Raquel V.', c: 'Zaragoza', t: 5, txt: 'Compré con dudas y ha sido todo un acierto. La calidad habla por sí sola.', d: '15 feb' },
    { n: 'Noelia M.', c: 'Málaga', t: 4, txt: 'Preciosa de verdad. Solo le pongo un pero: me encantaría que sacaran más colores.', d: 'hace 1 mes' },
    { n: 'Eva H.', c: 'Murcia', t: 5, txt: 'Sienta como un guante y el tejido es comodísimo. Una de mis prendas favoritas ya.', d: 'hace 5 días' }
  ];

  function nvHandle() {
    var p = (location.pathname.split('/products/')[1] || '');
    p = (p.split(/[/?#]/)[0] || 'novalise');
    return p.replace(/[^a-z0-9]/gi, '').toLowerCase() || 'novalise';
  }
  function nvHash(str) {
    var h = 2166136261;
    for (var i = 0; i < str.length; i++) { h ^= str.charCodeAt(i); h = (h * 16777619) >>> 0; }
    return h >>> 0;
  }
  function nvDayIndex() { return Math.floor(Date.now() / 86400000); }

  var nvLastCartCount = -1;
  function nvCartIsEmpty() {
    if (nvLastCartCount >= 0) return nvLastCartCount === 0;
    var item = document.querySelector('cart-items-component .cart-item, [class*="cart-item"]:not([class*="empty"])');
    return item === null;
  }
  function nvRemoveCartBars() {
    var drawer = document.querySelector('cart-drawer-component, [class*="cart-drawer"]') || document;
    ['.nv-cart-shipping', '.nv-qty-nudge', '.nv-cart-trust'].forEach(function (sel) {
      var els = drawer.querySelectorAll(sel);
      for (var i = 0; i < els.length; i++) if (els[i].parentNode) els[i].parentNode.removeChild(els[i]);
      if (sel === '.nv-cart-trust') {
        var t = document.querySelectorAll('.nv-cart-trust');
        for (var j = 0; j < t.length; j++) if (t[j].parentNode) t[j].parentNode.removeChild(t[j]);
      }
    });
  }

  function nvSelectReviews(hash) {
    var pool = REVIEWS_POOL;
    var count = 4 + (hash % 6);
    if (count > pool.length) count = pool.length;
    var offset = hash % pool.length;
    var step = 1 + (((hash >>> 4) % (pool.length - 1)) || 0);
    while (gcd(step, pool.length) !== 1) step++;
    var seen = {}, out = [];
    var idx = offset;
    while (out.length < count) {
      if (!seen[idx]) { seen[idx] = 1; out.push(pool[idx]); }
      idx = (idx + step) % pool.length;
    }
    return out;
  }
  function gcd(a, b) { while (b) { var t = b; b = a % b; a = t; } return a; }

  function nvAvgFromReviews(list) {
    if (!list || !list.length) return '4,8';
    var sum = 0;
    for (var i = 0; i < list.length; i++) sum += list[i].t;
    var avg = sum / list.length;
    var s = avg.toFixed(1);
    return s.replace('.', ',');
  }

  function nvProductContext() {
    var handle = nvHandle();
    var hash = nvHash(handle);
    var reviews = nvSelectReviews(hash);
    var avg = nvAvgFromReviews(reviews);
    return { handle: handle, hash: hash, reviews: reviews, avg: avg, count: reviews.length };
  }

  function nvAvgForHandle(handle) {
    var h = nvHash((handle || 'novalise').replace(/[^a-z0-9]/gi, '').toLowerCase() || 'novalise');
    return nvAvgFromReviews(nvSelectReviews(h));
  }

  function stars(t) {
    var s = '';
    for (var i = 1; i <= 5; i++) s += '<span class="nv-star' + (i <= t ? '' : ' nv-star--off') + '">★</span>';
    return '<span class="nv-stars" aria-hidden="true">' + s + '</span>';
  }

  function injectStyles() {
    if (document.getElementById('nv-cro-styles')) return;
    var st = document.createElement('style');
    st.id = 'nv-cro-styles';
    st.textContent = [
      'main[data-template^="product"] h1{font-size:clamp(1.6rem,2.4vw,2.1rem)!important;line-height:1.12!important}',
      '.nv-pdp-rating{font-size:.8rem!important;line-height:1.3!important;font-weight:400!important}',
      '.nv-scarcity{font-size:.74rem!important;line-height:1.3!important;font-weight:500!important}',
      '.nv-scarcity strong{font-weight:600!important}',
      '.nv-eta,.nv-guarantee{line-height:1.5!important;font-weight:400!important}',
      '.nv-eta strong,.nv-guarantee strong{font-weight:600!important}',
      '.nv-stars{display:inline-flex;gap:2px;color:#B8956A;font-size:.95rem!important;line-height:1;font-weight:400!important}',
      '.nv-star--off{color:#D9D3C7}',
      '.nv-pdp-rating{display:flex;align-items:center;gap:10px;margin:0 0 18px;font-family:Inter,sans-serif;font-size:.8rem;letter-spacing:.04em;color:#0F0F0F}',
      '.nv-pdp-rating a{color:#0F0F0F;text-decoration:underline;text-underline-offset:3px;opacity:.7}',
      '.nv-eta{display:flex;align-items:flex-start;gap:8px;margin:16px 0 0;padding:12px 14px;background:#F5F1E8;font-family:Inter,sans-serif;font-size:.8rem;line-height:1.5;color:#0F0F0F}',
      '.nv-eta strong{color:#0F0F0F}',
      '.nv-eta::before{content:"\\1F4E6";font-size:1rem;line-height:1.3;flex:0 0 auto}',
      '.nv-eta__txt{flex:1;min-width:0}',
      '.nv-guarantee{display:flex;align-items:center;gap:12px;margin:12px 0 0;padding:14px;border:1px solid #E8E5DD;font-family:Inter,sans-serif;font-size:.8rem;line-height:1.5;color:#0F0F0F}',
      '.nv-guarantee strong{color:#0F0F0F}',
      '.nv-guarantee__seal{flex:0 0 auto;width:40px;height:40px;border-radius:50%;border:1.5px solid #B8956A;color:#B8956A;display:flex;align-items:center;justify-content:center;font-family:"Playfair Display",Georgia,serif;font-size:1.05rem;font-weight:600}',
      '.nv-scarcity{display:inline-flex;align-items:center;gap:8px;margin:0 0 16px;padding:7px 13px;background:#FBF1E7;border:1px solid #E7D3BC;font-family:Inter,sans-serif;font-size:.74rem;letter-spacing:.04em;text-transform:uppercase;font-weight:500;color:#0F0F0F}',
      '.nv-scarcity strong{color:#B8956A;font-weight:600}',
      '.nv-scarcity__dot{width:7px;height:7px;border-radius:50%;background:#C0492B;animation:nvBlink 1.6s ease-in-out infinite}',
      '@keyframes nvBlink{0%,100%{opacity:1}50%{opacity:.25}}',
      '.nv-card-rating{display:flex;align-items:center;gap:5px;margin:6px 0 2px;font-family:Inter,sans-serif;font-size:.7rem;color:#0F0F0F;opacity:.85}',
      '.nv-card-rating .nv-stars{font-size:.72rem!important}',
      '.nv-pop{position:fixed;inset:0;z-index:1100;display:flex;align-items:center;justify-content:center;background:rgba(15,15,15,.55);opacity:0;pointer-events:none;transition:opacity .3s;padding:20px}',
      '.nv-pop.is-open{opacity:1;pointer-events:auto}',
      '.nv-pop__box{position:relative;background:#FAF8F4;max-width:380px;width:100%;padding:40px 32px 32px;text-align:center;border:1px solid #E8E5DD;transform:translateY(12px);transition:transform .3s;font-family:Inter,sans-serif}',
      '.nv-pop.is-open .nv-pop__box{transform:none}',
      '.nv-pop__x{position:absolute;top:10px;right:12px;background:none;border:none;font-size:1.6rem;line-height:1;color:#0F0F0F;cursor:pointer;opacity:.5}',
      '.nv-pop__eyebrow{font-size:.66rem;letter-spacing:.3em;text-transform:uppercase;color:#B8956A;margin:0 0 10px;font-weight:600}',
      '.nv-pop__title{font-family:"Playfair Display",Georgia,serif;font-size:1.9rem;font-weight:400;line-height:1.12;color:#0F0F0F;margin:0 0 12px}',
      '.nv-pop__sub{font-size:.8rem;line-height:1.55;color:#0F0F0F;opacity:.7;margin:0 0 18px}',
      '.nv-pop__code{display:flex;align-items:stretch;border:1px dashed #B8956A;margin:0 0 16px}',
      '.nv-pop__code span{flex:1;display:flex;align-items:center;justify-content:center;font-weight:600;letter-spacing:.12em;color:#0F0F0F;font-size:.9rem;padding:12px}',
      '.nv-pop__copy{border:none;border-left:1px dashed #B8956A;background:#F5F1E8;color:#0F0F0F;font-size:.7rem;letter-spacing:.08em;text-transform:uppercase;padding:0 16px;cursor:pointer}',
      '.nv-pop__cta{width:100%;background:#0F0F0F;color:#FAF8F4;border:1px solid #0F0F0F;padding:15px;font-size:.76rem;letter-spacing:.18em;text-transform:uppercase;font-weight:500;cursor:pointer;font-family:Inter,sans-serif}',
      '.nv-cart-trust{font-family:Inter,sans-serif;text-align:center;margin:0 0 12px}',
      '.nv-cart-trust__line{font-size:.74rem;letter-spacing:.04em;color:#0F0F0F;opacity:.8;margin-bottom:8px}',
      '.nv-cart-trust__pays{display:flex;flex-wrap:wrap;gap:6px;justify-content:center}',
      '.nv-cart-trust__pays span{font-size:.6rem;letter-spacing:.06em;text-transform:uppercase;color:#0F0F0F;opacity:.6;border:1px solid #E8E5DD;border-radius:3px;padding:3px 7px}',
      '.nv-reviews{margin:40px 0 8px;padding-top:28px;border-top:1px solid #E8E5DD;font-family:Inter,sans-serif}',
      '.nv-reviews__head{display:flex;align-items:baseline;gap:12px;margin-bottom:20px}',
      '.nv-reviews__avg{font-family:"Playfair Display",Georgia,serif;font-size:2rem;font-weight:400;color:#0F0F0F;line-height:1}',
      '.nv-reviews__meta{font-size:.74rem;letter-spacing:.1em;text-transform:uppercase;color:#0F0F0F;opacity:.65}',
      '.nv-review{padding:16px 0;border-bottom:1px solid #E8E5DD}',
      '.nv-review__top{display:flex;align-items:center;justify-content:space-between;margin-bottom:8px}',
      '.nv-review__who{font-size:.82rem;font-weight:500;color:#0F0F0F}',
      '.nv-review__who span{font-weight:400;opacity:.55;margin-left:6px}',
      '.nv-review__date{font-size:.66rem;letter-spacing:.04em;color:#0F0F0F;opacity:.45;margin-left:8px;font-weight:400}',
      '.nv-review__verified{font-size:.62rem;letter-spacing:.12em;text-transform:uppercase;color:#B8956A;font-weight:600}',
      '.nv-review__txt{font-size:.9rem;line-height:1.65;color:#0F0F0F;opacity:.85;margin:0}',
      '.nv-testi{background:#FAF8F4;padding:72px 24px 84px;border-top:1px solid #E8E5DD}',
      '.nv-testi__head{text-align:center;max-width:760px;margin:0 auto 40px}',
      '.nv-testi__eyebrow{font-family:Inter,sans-serif;font-size:.7rem;letter-spacing:.35em;text-transform:uppercase;color:#0F0F0F;opacity:.6;margin:0 0 12px}',
      '.nv-testi__title{font-family:"Playfair Display",Georgia,serif;font-size:clamp(1.6rem,3vw,2.4rem);font-weight:400;color:#0F0F0F;margin:0 0 10px;letter-spacing:-.02em}',
      '.nv-testi__avg{font-family:Inter,sans-serif;font-size:.82rem;letter-spacing:.08em;color:#0F0F0F;display:flex;gap:10px;align-items:center;justify-content:center}',
      '.nv-testi__grid{display:grid;grid-template-columns:repeat(3,1fr);gap:20px;max-width:1200px;margin:0 auto}',
      '.nv-testi__card{background:#fff;border:1px solid #E8E5DD;padding:26px 24px}',
      '.nv-testi__card .nv-review__txt{margin:10px 0 14px;font-size:.92rem}',
      '@media(max-width:900px){.nv-testi__grid{grid-template-columns:1fr;max-width:520px}.nv-testi{padding:52px 16px 60px}}',
      '.nv-msab{position:fixed;left:0;right:0;bottom:0;z-index:1090;display:flex;align-items:center;gap:12px;padding:10px 14px;padding-bottom:calc(10px + env(safe-area-inset-bottom));background:rgba(250,248,244,.97);-webkit-backdrop-filter:blur(8px);backdrop-filter:blur(8px);border-top:1px solid #E8E5DD;box-shadow:0 -6px 20px rgba(15,15,15,.08);transform:translateY(110%);transition:transform .28s ease;font-family:Inter,sans-serif}',
      '.nv-msab.is-on{transform:none}',
      '.nv-msab__info{flex:1;min-width:0}',
      '.nv-msab__name{font-size:.72rem;color:#0F0F0F;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;opacity:.65;letter-spacing:.02em}',
      '.nv-msab__price{font-family:"Playfair Display",Georgia,serif;font-size:1.05rem;color:#0F0F0F;line-height:1.15}',
      '.nv-msab__btn{flex:0 0 auto;background:#0F0F0F;color:#FAF8F4;border:none;padding:13px 24px;font-size:.7rem;letter-spacing:.16em;text-transform:uppercase;font-weight:600;cursor:pointer}',
      '.nv-msab__btn:active{opacity:.85}',
      '@media(min-width:750px){.nv-msab{display:none!important}}',
      '.nv-ups{padding:16px;border-top:1px solid #E8E5DD;font-family:Inter,sans-serif}',
      '.nv-ups__h{font-size:.64rem;letter-spacing:.2em;text-transform:uppercase;color:#0F0F0F;opacity:.55;margin:0 0 12px}',
      '.nv-ups__row{display:flex;gap:12px}',
      '.nv-ups__card{flex:1;min-width:0;text-decoration:none;color:inherit;display:block}',
      '.nv-ups__card img{width:100%;aspect-ratio:3/4;object-fit:cover;display:block;background:#F5F1E8}',
      '.nv-ups__t{font-size:.72rem;line-height:1.3;margin:7px 0 2px;color:#0F0F0F;display:-webkit-box;-webkit-line-clamp:1;-webkit-box-orient:vertical;overflow:hidden}',
      '.nv-ups__p{font-size:.74rem;color:#0F0F0F;font-weight:600}',
      '.nv-clook{margin:36px 0 8px;padding-top:28px;border-top:1px solid #E8E5DD;font-family:Inter,sans-serif}',
      '.nv-clook__h{font-family:"Playfair Display",Georgia,serif;font-size:1.25rem;font-weight:400;color:#0F0F0F;margin:0 0 4px}',
      '.nv-clook__sub{font-size:.72rem;letter-spacing:.04em;color:#0F0F0F;opacity:.55;margin:0 0 18px}',
      '.nv-clook__row{display:grid;grid-template-columns:repeat(4,1fr);gap:16px}',
      '@media(max-width:749px){.nv-clook__row{grid-template-columns:repeat(2,1fr);gap:12px}}',
      '.nv-clook__card{text-decoration:none;color:inherit;display:block}',
      '.nv-clook__card img{width:100%;aspect-ratio:3/4;object-fit:cover;display:block;background:#F5F1E8}',
      '.nv-clook__t{font-size:.78rem;line-height:1.3;margin:8px 0 2px;color:#0F0F0F;display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical;overflow:hidden}',
      '.nv-clook__p{font-size:.8rem;color:#0F0F0F;font-weight:600}',
      '.nv-faq{max-width:820px;margin:0 auto;padding:64px 24px 8px;font-family:Inter,sans-serif}',
      '.nv-faq__eyebrow{text-align:center;font-size:.7rem;letter-spacing:.35em;text-transform:uppercase;color:#0F0F0F;opacity:.55;margin:0 0 10px}',
      '.nv-faq__title{text-align:center;font-family:"Playfair Display",Georgia,serif;font-size:clamp(1.6rem,3vw,2.3rem);font-weight:400;color:#0F0F0F;margin:0 0 32px;letter-spacing:-.02em}',
      '.nv-faq__item{border-bottom:1px solid #E8E5DD}',
      '.nv-faq__q{width:100%;background:none;border:none;text-align:left;display:flex;justify-content:space-between;align-items:center;gap:16px;padding:20px 4px;font-family:Inter,sans-serif;font-size:.92rem;font-weight:500;color:#0F0F0F;cursor:pointer}',
      '.nv-faq__q::after{content:"+";font-size:1.3rem;color:#B8956A;flex:0 0 auto}',
      '.nv-faq__item.is-open .nv-faq__q::after{content:"\\2212"}',
      '.nv-faq__a{max-height:0;overflow:hidden;transition:max-height .3s ease;font-size:.88rem;line-height:1.65;color:#0F0F0F;opacity:.8}',
      '.nv-faq__a p{margin:0 4px 20px}',
      '.nv-look{padding:64px 16px 8px;font-family:Inter,sans-serif}',
      '.nv-look__head{text-align:center;max-width:680px;margin:0 auto 28px}',
      '.nv-look__eyebrow{font-size:.72rem;letter-spacing:.3em;text-transform:uppercase;color:#B8956A;margin:0 0 8px;font-weight:600}',
      '.nv-look__title{font-family:"Playfair Display",Georgia,serif;font-size:clamp(1.6rem,3vw,2.4rem);font-weight:400;color:#0F0F0F;margin:0 0 8px;letter-spacing:-.02em}',
      '.nv-look__sub{font-size:.82rem;line-height:1.55;color:#0F0F0F;opacity:.6;margin:0}',
      '.nv-look__grid{display:grid;grid-template-columns:repeat(4,1fr);gap:8px;max-width:1200px;margin:0 auto}',
      '@media(max-width:749px){.nv-look__grid{grid-template-columns:repeat(2,1fr)}}',
      '.nv-look__cell{position:relative;display:block;overflow:hidden;aspect-ratio:1/1;background:#F5F1E8}',
      '.nv-look__cell img{width:100%;height:100%;object-fit:cover;display:block;transition:transform .5s ease}',
      '.nv-look__cell:hover img{transform:scale(1.06)}',
      '.nv-look__tag{position:absolute;left:50%;bottom:14px;transform:translateX(-50%) translateY(8px);background:rgba(250,248,244,.95);color:#0F0F0F;font-size:.62rem;letter-spacing:.18em;text-transform:uppercase;font-weight:600;padding:7px 16px;opacity:0;transition:opacity .25s,transform .25s}',
      '.nv-look__cell:hover .nv-look__tag{opacity:1;transform:translateX(-50%) translateY(0)}',
      '.nv-tb{display:flex;gap:8px;margin:14px 0 0;padding:0}',
      '.nv-tb__item{flex:1;display:flex;flex-direction:column;align-items:center;text-align:center;gap:5px;padding:12px 6px;border:1px solid #E8E5DD;background:#FAF8F4}',
      '.nv-tb__ic{width:20px;height:20px;color:#B8956A}',
      '.nv-tb__t{font-family:Inter,sans-serif;font-size:.62rem;letter-spacing:.08em;text-transform:uppercase;font-weight:600;color:#0F0F0F;line-height:1.25}',
      '@media(max-width:480px){.nv-tb__t{font-size:.56rem}.nv-tb__item{padding:10px 4px}}',
      '.nv-qty-nudge{font-family:Inter,sans-serif;font-size:.72rem;letter-spacing:.04em;line-height:1.4;color:#0F0F0F;text-align:center;margin:0 0 12px;padding:9px 14px;background:#FBF1E7;border:1px solid #E7D3BC}',
      '.nv-qty-nudge strong{color:#B8956A;font-weight:600}',
      '.nv-qty-nudge--on{background:#F5F1E8;border-color:#E8E5DD}',
      '.nv-qty-pdp{font-family:Inter,sans-serif;font-size:.74rem;letter-spacing:.04em;line-height:1.4;color:#0F0F0F;opacity:.85;margin:10px 0 0}',
      '.nv-qty-pdp strong{color:#B8956A;font-weight:600}',
      '.nv-hero-offer{display:inline-flex;align-items:center;gap:8px;margin:18px 0 0;font-family:Inter,sans-serif;text-transform:uppercase;font-weight:600;background:#0F0F0F!important;color:#FAF8F4!important;border:1px solid #0F0F0F!important;border-radius:0!important;padding:11px 18px!important;font-size:.7rem!important;letter-spacing:.12em!important;box-shadow:0 6px 20px rgba(0,0,0,.25)!important}',
      '.nv-hero-offer strong{font-weight:700;color:#D4B483!important;font-size:1rem!important;letter-spacing:.04em!important}',
      '.nv-price-clean{display:none!important}',
      '.nv-salewrap{display:inline-flex;align-items:center;gap:9px;margin-left:10px;vertical-align:middle}',
      '.nv-was{text-decoration:line-through;color:#9a9286;font-weight:400;font-size:.82em;letter-spacing:.01em}',
      '.nv-off{background:#B8956A;color:#FAF8F4;font-family:Inter,sans-serif;font-size:.6rem;font-weight:600;letter-spacing:.08em;padding:3px 7px;border-radius:2px;line-height:1;white-space:nowrap}',
      '[class*="product-card"] .nv-salewrap,.product-card .nv-salewrap,.card .nv-salewrap{gap:6px;margin-left:7px}',
      '[class*="product-card"] .nv-was,.card .nv-was{font-size:.8em}',
      '@media (max-width:749px){.nv-cart-shipping{padding:14px 22px!important}.nv-cart-shipping__msg{margin-top:6px!important}.nv-qty-nudge{padding:8px 22px!important}}',
      '.nv-hero-social{display:inline-flex;align-items:center;gap:9px;margin:14px 0 0;font-family:Inter,sans-serif;font-size:.68rem;letter-spacing:.14em;text-transform:uppercase;color:#FAF8F4!important;text-shadow:0 1px 8px rgba(0,0,0,.55)!important}',
      '.nv-hero-social .nv-stars{font-size:.82rem!important;color:#E8C9A0!important}',
      '.nv-hero-social span{line-height:1.3}',
      '.nv-clook__hint{font-size:.74rem;letter-spacing:.02em;line-height:1.45;color:#0F0F0F;opacity:.7;margin:0 0 18px}',
      '.nv-clook__hint strong{color:#B8956A;font-weight:600}',
      'fieldset.nv-swatched{display:flex!important;flex-wrap:wrap;gap:8px 12px;border:0!important;padding:0!important;margin:0 0 4px;background:none!important}',
      'fieldset.nv-swatched .variant-option__button-label,fieldset.nv-swatched label{display:inline-flex!important;flex-direction:column;align-items:center;gap:0;padding:4px 6px!important;min-width:52px;cursor:pointer;border:none!important;background:none!important;box-shadow:none!important;border-radius:0!important;outline:none!important}',
      'fieldset.nv-swatched .variant-option__button-label:before,fieldset.nv-swatched .variant-option__button-label:after,fieldset.nv-swatched label:before,fieldset.nv-swatched label:after{display:none!important;border:none!important;background:none!important;box-shadow:none!important}',
      'fieldset.nv-swatched .nv-sw{width:26px;height:26px;border-radius:50%;border:1px solid rgba(0,0,0,.12);box-shadow:0 1px 3px rgba(0,0,0,.12);display:block;margin:0 auto 5px;transition:outline .12s,box-shadow .15s,transform .15s}',
      'fieldset.nv-swatched .nv-sw--light,fieldset.nv-swatched .nv-sw.nv-sw--light{border-color:#C9C2B5}',
      'fieldset.nv-swatched .nv-sw-hidetext{display:none!important}',
      'fieldset.nv-swatched .nv-sw-name{font-size:.6rem;letter-spacing:.04em;text-transform:uppercase;color:#0F0F0F;opacity:.7;text-align:center;display:block;line-height:1.2;min-width:56px;white-space:nowrap;overflow:visible}',
      'fieldset.nv-swatched .variant-option__button-label:hover .nv-sw,fieldset.nv-swatched label:hover .nv-sw{transform:translateY(-1px);box-shadow:0 2px 6px rgba(0,0,0,.18)}',
      'fieldset.nv-swatched label:has(input:checked) .nv-sw,fieldset.nv-swatched .variant-option__button-label:has(input:checked) .nv-sw{outline:2px solid #0F0F0F;outline-offset:2px}',
      'fieldset.nv-swatched label:has(input:checked) .nv-sw-name,fieldset.nv-swatched .variant-option__button-label:has(input:checked) .nv-sw-name{opacity:1;font-weight:600}',
      /* ANTI-FLASH: keyed on the STABLE data-option-id that survives Horizon\'s
       * variant re-render. .nv-swatched is stripped on every re-render, so for
       * ~50ms the native color-name text pills ("ROJO") flashed. These rules
       * pre-hide native text + lay out the color fieldset as swatch slots
       * ALWAYS, so no old text bars ever show — the colored circle just snaps in. */
      'fieldset[data-option-id$="-color"],fieldset[data-option-id$="-colour"],fieldset[data-option-id$="-colore"],fieldset[data-option-id$="-color-1"]{display:flex!important;flex-wrap:wrap;gap:8px 12px;border:0!important;padding:0!important;margin:0 0 4px;background:none!important}',
      'fieldset[data-option-id$="-color"] .variant-option__button-label,fieldset[data-option-id$="-color"] label,fieldset[data-option-id$="-colour"] .variant-option__button-label,fieldset[data-option-id$="-colour"] label,fieldset[data-option-id$="-colore"] .variant-option__button-label,fieldset[data-option-id$="-colore"] label{display:inline-flex!important;flex-direction:column;align-items:center;gap:0;padding:4px 6px!important;min-width:52px;cursor:pointer;border:none!important;background:none!important;box-shadow:none!important;border-radius:0!important;outline:none!important;font-size:0!important;color:transparent!important}',
      'fieldset[data-option-id$="-color"] .variant-option__button-label:after,fieldset[data-option-id$="-colour"] .variant-option__button-label:after,fieldset[data-option-id$="-colore"] .variant-option__button-label:after{display:none!important;border:none!important;background:none!important}',
      'fieldset[data-option-id$="-color"] .variant-option__button-label:not(:has(.nv-sw)):before,fieldset[data-option-id$="-colour"] .variant-option__button-label:not(:has(.nv-sw)):before,fieldset[data-option-id$="-colore"] .variant-option__button-label:not(:has(.nv-sw)):before{content:"";display:block!important;width:26px;height:26px;border-radius:50%;margin:0 auto 5px;background:#E8E5DD;border:1px solid rgba(0,0,0,.12)}',
      'fieldset[data-option-id$="-color"] .nv-sw-name,fieldset[data-option-id$="-colour"] .nv-sw-name,fieldset[data-option-id$="-colore"] .nv-sw-name{font-size:.6rem!important;color:#0F0F0F!important;opacity:.7}',
      /* CART SAFETY: the editorial empty-cart block must NEVER render when the
       * cart actually has line items. Pure-CSS guard keyed on Horizon\'s real
       * row class so it holds even if JS detection misfires (was the iOS bug). */
      'cart-drawer-component:has(.cart-items__table-row) .nv-cart-empty-editorial,cart-items-component:has(.cart-items__table-row) .nv-cart-empty-editorial,[class*="cart-drawer"]:has(.cart-items__table-row) .nv-cart-empty-editorial,cart-drawer-component:has(.cart-items__table-row) [data-nv-empty],cart-items-component:has(.cart-items__table-row) [data-nv-empty]{display:none!important}',
      /* CART MOBILE OVERLAP FIX: sticky summary taller than the mobile scroller gets pushed up over the item rows; on mobile make it static so items+summary stack and the drawer scrolls. */
      '@media (max-width:749px){.cart-drawer__summary{position:static!important;bottom:auto!important}.cart-drawer__content{min-height:0!important;overflow-y:auto!important}.cart-drawer__items{flex:0 0 auto!important}}'
    ].join('');
    document.head.appendChild(st);
  }

  function fixCartCopy(scope) {
    var root = scope || document;
    root.querySelectorAll('.cart-totals__total-label').forEach(function (el) {
      if (el.dataset.nvFixed) return;
      el.textContent = 'Total';
      el.dataset.nvFixed = '1';
    });
    root.querySelectorAll('.cart-totals__tax-note').forEach(function (el) {
      if (el.dataset.nvFixed) return;
      el.innerHTML = '<small>Envío gratuito en España. Impuestos calculados en el pago.</small>';
      el.dataset.nvFixed = '1';
    });
  }

  var SHIP_HTML = '<div class="nv-cart-shipping"><div class="nv-cart-shipping__label"><span>Envío gratuito</span><span style="color:#B8956A;">✓ Conseguido</span></div><div class="nv-cart-shipping__bar"><div class="nv-cart-shipping__fill" style="width:100%;"></div></div><p class="nv-cart-shipping__msg">Tu pedido se entrega <strong>gratis en España</strong>. Seguimiento incluido en cuanto se procesa.</p></div>';
  function injectShipping() {
    var drawer = document.querySelector('cart-drawer-component, [class*="cart-drawer"]');
    if (!drawer) return;
    if (nvCartIsEmpty()) { nvRemoveCartBars(); return; }
    if (drawer.querySelector('.nv-cart-shipping')) return;
    var header = drawer.querySelector('header, [class*="cart-drawer__header"]');
    var target = header || drawer.querySelector('[class*="cart-drawer__items"], [class*="cart-items"]');
    if (target) {
      var node = document.createElement('div');
      node.innerHTML = SHIP_HTML;
      target.insertAdjacentElement('afterend', node.firstElementChild);
    }
  }

  function nvQtyNudge() {
    var drawer = document.querySelector('cart-drawer-component, [class*="cart-drawer"]');
    if (!drawer) return;
    if (nvCartIsEmpty()) { nvRemoveCartBars(); return; }
    function readCount() {
      var cc = document.querySelector('.cart-count, [class*="cart-count"], [data-cart-count]');
      if (cc) {
        var m = (cc.textContent || '').match(/\d+/);
        if (m) return parseInt(m[0], 10);
      }
      var qty = 0, inputs = drawer.querySelectorAll('input[name="updates[]"], [class*="quantity"] input, input.quantity__input');
      for (var i = 0; i < inputs.length; i++) {
        var v = parseInt(inputs[i].value, 10);
        if (!isNaN(v)) qty += v;
      }
      return qty;
    }
    function render(count) {
      var on = count >= 2;
      var el = drawer.querySelector('.nv-qty-nudge');
      if (!el) {
        var header = drawer.querySelector('header, [class*="cart-drawer__header"]');
        var shipBar = drawer.querySelector('.nv-cart-shipping');
        var anchor = shipBar || header || drawer.querySelector('[class*="cart-drawer__items"], [class*="cart-items"]');
        if (!anchor) return;
        el = document.createElement('div');
        el.className = 'nv-qty-nudge';
        anchor.insertAdjacentElement('afterend', el);
      }
      var html = on
        ? '<strong>✓ 10% aplicado</strong> por llevar 2+ piezas.'
        : 'Añade 1 pieza más y ahorra un <strong>10%</strong> en tu pedido.';
      if (el.dataset.nvState !== (on ? 'on' : 'off') || el.innerHTML.indexOf('10%') === -1) {
        el.innerHTML = html;
        el.dataset.nvState = on ? 'on' : 'off';
      }
      el.classList.toggle('nv-qty-nudge--on', on);
    }
    var domCount = readCount();
    if (domCount > 0) render(domCount);
    fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
      if (cart && typeof cart.item_count === 'number') {
        nvLastCartCount = cart.item_count;
        if (cart.item_count === 0) { nvRemoveCartBars(); return; }
        render(cart.item_count);
      }
    }).catch(function () { if (!(domCount > 0)) render(0); });
  }

  function pdpETA(main) {
    if (main.querySelector('.nv-eta')) return;
    var atc = main.querySelector('[name="add"]');
    if (!atc) return;
    var anchor = atc.closest('.product-form__buttons, buy-buttons-component, .buy-buttons, form') || atc.parentElement;
    if (!anchor) return;
    var eta = document.createElement('div');
    eta.className = 'nv-eta';
    eta.innerHTML = '<span class="nv-eta__txt">Envío <strong>Premium gratis</strong> a toda España · Seguimiento de tu pedido <strong>incluido</strong>.</span>';
    anchor.insertAdjacentElement('afterend', eta);
    var g = document.createElement('div');
    g.className = 'nv-guarantee';
    g.innerHTML = '<span class="nv-guarantee__seal">30</span><div><strong>Cambio de talla gratis · 30 días.</strong> Si la talla no es perfecta, te la cambiamos sin coste. Devoluciones gratuitas.</div>';
    eta.insertAdjacentElement('afterend', g);
  }

  function pdpScarcity(main) {
    if (main.querySelector('.nv-scarcity')) return;
    var h1 = main.querySelector('h1');
    if (!h1) return;
    var hash = nvHash(nvHandle());
    var base = 3 + (hash % 8);
    var drift = Math.floor((nvDayIndex() + (hash % 5)) / 3) % 5;
    var n = base - drift;
    if (n < 2) n = 2 + ((hash + nvDayIndex()) % 4);
    if (n > 12) n = 12;
    var s = document.createElement('div');
    s.className = 'nv-scarcity';
    s.innerHTML = '<span class="nv-scarcity__dot"></span>Edición limitada · quedan <strong>' + n + ' unidades</strong>';
    var rt = main.querySelector('.nv-pdp-rating') || h1.closest('.text-block, [class*="text-block"]') || h1;
    rt.insertAdjacentElement('afterend', s);
  }

  var NV_COLOR_MAP = [
    [['rosa pastel', 'rosa claro', 'light pink'], '#F4C7D6'],
    [['rosso vino', 'vino', 'burdeos', 'borgogna', 'wine'], '#6E1A2B'],
    [['rosa', 'pink', 'rose'], '#E8A0BF'],
    [['magenta'], '#C2407A'],
    [['rojo', 'rosso', 'red'], '#C0392B'],
    [['naranja', 'arancia', 'orange'], '#E67E22'],
    [['albaricoque', 'albicocca', 'melocoton', 'peach', 'coral'], '#F2A07B'],
    [['amarillo claro', 'light yellow'], '#F7E9A0'],
    [['amarillo', 'giallo', 'yellow'], '#F1C40F'],
    [['verde claro', 'verde chiaro', 'light green'], '#8FBF7F'],
    [['verde oliva', 'oliva', 'militar', 'olive'], '#6B6B3A'],
    [['matcha', 'menta', 'sage', 'mint'], '#A9C9A4'],
    [['verde', 'green'], '#3A7D44'],
    [['turquesa', 'cyan'], '#1ABC9C'],
    [['teal'], '#1F8A8A'],
    [['azul marino', 'marina', 'navy', 'blu navy'], '#1B2A4A'],
    [['azul claro', 'azzurro', 'light blue', 'celeste'], '#8FB8E0'],
    [['azul pavo', 'pavone', 'peacock'], '#1E6F8E'],
    [['azul', 'blu', 'blue'], '#2C5AA0'],
    [['morado', 'viola', 'lila', 'purpura', 'purple', 'violet'], '#7D3C98'],
    [['marron claro', 'marrone chiaro', 'camel', 'tostado', 'tan', 'caqui'], '#B5895B'],
    [['marron', 'marrone', 'cafe', 'caffe', 'brown', 'chocolate'], '#7B4A2D'],
    [['beige', 'crema', 'cream', 'nude', 'sand', 'bianco crema'], '#D8C3A5'],
    [['gris claro', 'grigio chiaro', 'light gray', 'light grey'], '#BFBFBF'],
    [['gris oscuro', 'grigio scuro', 'dark gray', 'dark grey'], '#4A4A4A'],
    [['gris', 'grigio', 'grey', 'gray'], '#8C8C8C'],
    [['talpa', 'taupe'], '#8B7E6A'],
    [['negro', 'nero', 'black'], '#111111'],
    [['blanco', 'white', 'bianco'], '#FFFFFF'],
    [['plata', 'silver', 'argento'], '#C0C0C0'],
    [['oro', 'dorado', 'gold'], '#C9A24B'],
    [['leopardo', 'serpiente', 'animal', 'leopard', 'snake', 'print'], 'linear-gradient(135deg,#B5895B,#7B4A2D 50%,#3a2c1e)']
  ];
  function nvNormColor(s) {
    s = (s || '').toString().toLowerCase();
    s = s.replace(/™/g, '').replace(/\(.*?\)/g, '');
    s = s.normalize ? s.normalize('NFD').replace(/[̀-ͯ]/g, '') : s;
    return s.replace(/\s+/g, ' ').trim();
  }
  function nvColorHex(name) {
    var n = nvNormColor(name);
    for (var i = 0; i < NV_COLOR_MAP.length; i++) {
      var keys = NV_COLOR_MAP[i][0];
      for (var k = 0; k < keys.length; k++) {
        if (n === keys[k] || n.indexOf(keys[k]) !== -1) return NV_COLOR_MAP[i][1];
      }
    }
    return null;
  }
  var nvSwBusy = false;
  var nvSwObserved = false;
  var nvSwTimer = null;
  function nvSwIsColorFieldset(fs) {
    var legend = fs.querySelector('legend, label, [class*="variant-option__name"], [class*="option-name"]');
    var legendTxt = (legend ? legend.textContent : '') || fs.getAttribute('aria-label') || '';
    if (/color|colour|colore/i.test(legendTxt) || /color|colour|colore/i.test(fs.className)) return true;
    var probe = fs.querySelector('input[type="radio"]');
    var pName = probe ? (probe.getAttribute('name') || '') : '';
    return /color|colour|colore/i.test(pName);
  }
  // Hide the native color-name text inside a variant label so it doesn't duplicate .nv-sw-name.
  // Idempotent: skips inputs, our injected .nv-sw / .nv-sw-name, and anything already hidden.
  function nvSwHideNativeText(lab) {
    if (!lab || lab.getAttribute('data-nv-texthidden') === '1') return;
    var kids = lab.childNodes;
    for (var i = 0; i < kids.length; i++) {
      var node = kids[i];
      if (node.nodeType === 3) {
        if (node.nodeValue && node.nodeValue.replace(/\s+/g, '') !== '') {
          var wrap = document.createElement('span');
          wrap.className = 'nv-sw-hidetext';
          lab.replaceChild(wrap, node);
          wrap.appendChild(node);
        }
      } else if (node.nodeType === 1) {
        if (node.tagName === 'INPUT') continue;
        if (node.classList && (node.classList.contains('nv-sw') || node.classList.contains('nv-sw-name') || node.classList.contains('nv-sw-hidetext'))) continue;
        if (node.classList) node.classList.add('nv-sw-hidetext');
      }
    }
    lab.setAttribute('data-nv-texthidden', '1');
  }
  function nvColorSwatches(main) {
    var scope = main || document;
    nvSwBusy = true;
    try {
      var fsets = scope.querySelectorAll('fieldset');
      for (var f = 0; f < fsets.length; f++) {
        var fs = fsets[f];
        if (!nvSwIsColorFieldset(fs)) continue;
        var labels = fs.querySelectorAll('.variant-option__button-label, label');
        if (!labels.length) continue;
        var applied = 0, needed = 0;
        for (var l = 0; l < labels.length; l++) {
          var lab = labels[l];
          var input = lab.querySelector('input[type="radio"], input');
          if (!input) continue;
          needed++;
          if (lab.querySelector('.nv-sw')) { applied++; continue; }
          var val = input.value || input.getAttribute('value') || (lab.textContent || '').trim();
          if (!val) continue;
          // Hide native color text so it doesn't duplicate the injected .nv-sw-name.
          nvSwHideNativeText(lab);
          var hex = nvColorHex(val);
          var sw = document.createElement('span');
          sw.className = 'nv-sw';
          sw.style.background = hex || '#D8D2C6';
          if ((hex && /#fff|#FFF|#D8C3A5/i.test(hex)) || (!hex)) sw.className += ' nv-sw--light';
          var nm = document.createElement('span');
          nm.className = 'nv-sw-name';
          nm.textContent = (val || '').toString();
          lab.insertBefore(sw, lab.firstChild);
          lab.appendChild(nm);
          applied++;
        }
        if (needed && applied) fs.classList.add('nv-swatched');
      }
    } finally {
      setTimeout(function () { nvSwBusy = false; }, 0);
    }
    nvSwSetupObserver(main);
  }
  function nvSwRerun() {
    if (nvSwTimer) clearTimeout(nvSwTimer);
    nvSwTimer = setTimeout(function () {
      var pm = document.querySelector('main[data-template^="product"]') || document;
      nvColorSwatches(pm);
    }, 16);
  }
  function nvSwSetupObserver(main) {
    if (nvSwObserved) return;
    var root = (main || document).querySelector('variant-picker, product-form-component, [class*="variant-picker"], .product-form, product-form');
    if (!root) root = main && main.querySelector ? main : document.querySelector('main[data-template^="product"]');
    if (!root) return;
    nvSwObserved = true;
    var obs = new MutationObserver(function () {
      if (nvSwBusy) return;
      nvSwRerun();
    });
    obs.observe(root, { childList: true, subtree: true });
    document.addEventListener('variant:change', nvSwRerun);
    document.addEventListener('variant:update', nvSwRerun);
    document.addEventListener('change', function (e) {
      var t = e.target;
      if (t && t.matches && t.matches('input[type="radio"], select')) nvSwRerun();
    });
  }

  function pdpQtyHint(main) {
    if (main.dataset.nvQtyPdp || main.querySelector('.nv-qty-pdp')) return;
    var atc = main.querySelector('[name="add"]');
    if (!atc) return;
    var anchor = main.querySelector('.nv-tb') ||
      atc.closest('.product-form__buttons, buy-buttons-component, .buy-buttons, form') || atc.parentElement;
    if (!anchor) return;
    main.dataset.nvQtyPdp = '1';
    var hint = document.createElement('div');
    hint.className = 'nv-qty-pdp';
    hint.innerHTML = 'Llévate 2 o más piezas y ahorra un <strong>10%</strong>.';
    anchor.insertAdjacentElement('afterend', hint);
  }

  function cartTrust() {
    if (nvCartIsEmpty()) { nvRemoveCartBars(); return; }
    var ctas = document.querySelector('.cart__ctas');
    if (!ctas || document.querySelector('.nv-cart-trust')) return;
    var t = document.createElement('div');
    t.className = 'nv-cart-trust';
    t.innerHTML = '<div class="nv-cart-trust__line">🔒 Pago 100% seguro · Garantía de 30 días</div>' +
      '<div class="nv-cart-trust__pays"><span>Bizum</span><span>Visa</span><span>Mastercard</span><span>Apple&nbsp;Pay</span><span>Shop&nbsp;Pay</span></div>';
    ctas.insertAdjacentElement('beforebegin', t);
  }

  function pdpReviews(main) {
    var ctx = nvProductContext();
    var reviews = ctx.reviews;
    var avg = ctx.avg;
    var count = ctx.count;
    var h1 = main.querySelector('h1');
    if (h1 && !main.querySelector('.nv-pdp-rating')) {
      var rt = document.createElement('div');
      rt.className = 'nv-pdp-rating';
      rt.innerHTML = stars(5) + '<span>' + avg + '/5 · ' + count + ' valoraciones</span><a href="#nv-reviews">Ver valoraciones</a>';
      var anchorEl = h1.closest('.text-block, [class*="text-block"]') || h1;
      anchorEl.insertAdjacentElement('afterend', rt);
    }
    if (main.querySelector('#nv-reviews')) return;
    var anchor = null, ps = main.querySelectorAll('p');
    for (var i = 0; i < ps.length; i++) {
      if (/30 días/.test(ps[i].textContent) && /envío/i.test(ps[i].textContent)) { anchor = ps[i]; break; }
    }
    var block = document.createElement('div');
    block.className = 'nv-reviews';
    block.id = 'nv-reviews';
    var html = '<div class="nv-reviews__head">' + stars(5) +
      '<span class="nv-reviews__avg">' + avg + '</span>' +
      '<span class="nv-reviews__meta">' + count + ' valoraciones verificadas de clientas</span></div>';
    reviews.forEach(function (r) {
      html += '<div class="nv-review"><div class="nv-review__top"><span class="nv-review__who">' + r.n +
        '<span>' + r.c + '</span><span class="nv-review__date">' + r.d + '</span></span><span class="nv-review__verified">✓ Compra verificada</span></div>' +
        stars(r.t) + '<p class="nv-review__txt">' + r.txt + '</p></div>';
    });
    block.innerHTML = html;
    if (anchor) anchor.insertAdjacentElement('afterend', block);
    else {
      var det = main.querySelector('details');
      if (det && det.parentElement) det.parentElement.insertAdjacentElement('beforebegin', block);
    }
  }

  function collectionCards() {
    var cards = document.querySelectorAll('.product-card, product-card, [class*="card-product"], [class*="product-card"]');
    cards.forEach(function (card) {
      if (card.dataset.nvCard) return;
      var link = card.querySelector('a[href*="/products/"]');
      if (!link) return;
      if (card.parentElement && card.parentElement.closest('[data-nv-card="1"]')) { card.dataset.nvCard = '1'; return; }
      if (card.querySelector('.nv-card-rating')) { card.dataset.nvCard = '1'; return; }
      card.dataset.nvCard = '1';
      var hm = (link.getAttribute('href') || '').match(/\/products\/([^/?#]+)/);
      var handle = hm ? hm[1] : 'novalise';
      var cardAvg = nvAvgForHandle(handle);
      var chip = document.createElement('div');
      chip.className = 'nv-card-rating';
      chip.innerHTML = stars(5) + '<span>' + cardAvg + '</span>';
      var titleEl = card.querySelector('[class*="title"], [class*="product-card__title"]');
      if (titleEl) titleEl.insertAdjacentElement('beforebegin', chip);
      else card.appendChild(chip);
    });
  }

  function welcomePopup() {
    try { if (localStorage.getItem('nv_pop')) return; } catch (e) {}
    if (document.querySelector('.nv-pop')) return;
    if (location.pathname.indexOf('/cart') === 0 || location.pathname.indexOf('/checkout') === 0) return;
    var ov = document.createElement('div');
    ov.className = 'nv-pop';
    ov.innerHTML =
      '<div class="nv-pop__box" role="dialog" aria-label="Oferta de bienvenida">' +
      '<button class="nv-pop__x" aria-label="Cerrar">&times;</button>' +
      '<p class="nv-pop__eyebrow">Bienvenida a NOVALISE</p>' +
      '<h3 class="nv-pop__title">10% en tu<br>primera compra</h3>' +
      '<p class="nv-pop__sub">Usa este código en el carrito. Envío gratis en España · Cambios y devoluciones en 30 días.</p>' +
      '<div class="nv-pop__code"><span>BIENVENIDA10</span><button type="button" class="nv-pop__copy">Copiar</button></div>' +
      '<button type="button" class="nv-pop__cta">Empezar a comprar</button>' +
      '</div>';
    function close() { ov.classList.remove('is-open'); try { localStorage.setItem('nv_pop', '1'); } catch (e) {} setTimeout(function () { ov.remove(); }, 300); }
    ov.addEventListener('click', function (e) { if (e.target === ov || e.target.closest('.nv-pop__x, .nv-pop__cta')) close(); });
    ov.querySelector('.nv-pop__copy').addEventListener('click', function () {
      try { navigator.clipboard.writeText('BIENVENIDA10'); } catch (e) {}
      this.textContent = '¡Copiado!';
    });
    document.body.appendChild(ov);
    setTimeout(function () { ov.classList.add('is-open'); }, 50);
  }

  function homeTestimonials() {
    var main = document.querySelector('main[data-template^="index"]');
    if (!main || document.querySelector('.nv-testi')) return;
    var footer = document.querySelector('footer');
    if (!footer) return;
    var pool = REVIEWS_POOL;
    var off = (nvHash('home') + nvDayIndex()) % pool.length;
    var chosen = [pool[off % pool.length], pool[(off + 7) % pool.length], pool[(off + 13) % pool.length]];
    var sum = 0; chosen.forEach(function (r) { sum += r.t; });
    var hAvg = (sum / chosen.length).toFixed(1).replace('.', ',');
    var sec = document.createElement('section');
    sec.className = 'nv-testi';
    var cards = chosen.map(function (r) {
      return '<div class="nv-testi__card"><div class="nv-review__top"><span class="nv-review__who">' + r.n +
        '<span>' + r.c + '</span><span class="nv-review__date">' + r.d + '</span></span><span class="nv-review__verified">✓ Verificada</span></div>' +
        stars(r.t) + '<p class="nv-review__txt">' + r.txt + '</p></div>';
    }).join('');
    sec.innerHTML = '<div class="nv-testi__head"><p class="nv-testi__eyebrow">Lo que dicen nuestras clientas</p>' +
      '<h2 class="nv-testi__title">Amado en toda España</h2>' +
      '<div class="nv-testi__avg">' + stars(5) + '<span>' + hAvg + '/5 · valoraciones verificadas</span></div></div>' +
      '<div class="nv-testi__grid">' + cards + '</div>';
    footer.insertAdjacentElement('beforebegin', sec);
  }

  function nvHeroOffer() {
    var main = document.querySelector('main[data-template^="index"]');
    if (!main) return;
    if (document.querySelector('.nv-hero-offer')) return;
    var hero = main.querySelector('.nv-hero-editorial-section') || main.querySelector('section');
    if (!hero) return;
    var cta = hero.querySelector('a[href*="/collections"], a[href*="/products"], .button, [class*="button"], a[class*="btn"], a');
    var headline = hero.querySelector('h1, h2, [class*="headline"], [class*="title"]');
    var anchor = cta || headline;
    if (!anchor) return;
    var chip = document.createElement('div');
    chip.className = 'nv-hero-offer';
    chip.innerHTML = '<strong>−10%</strong> en tu primera compra · código BIENVENIDA10';
    anchor.insertAdjacentElement('afterend', chip);
  }

  function nvHeroSocial() {
    var main = document.querySelector('main[data-template^="index"]');
    if (!main) return;
    if (document.querySelector('.nv-hero-social')) return;
    var hero = main.querySelector('.nv-hero-editorial-section') || main.querySelector('section');
    if (!hero) return;
    var offer = hero.querySelector('.nv-hero-offer') || document.querySelector('.nv-hero-offer');
    var anchor = offer;
    if (!anchor) {
      anchor = hero.querySelector('a[href*="/collections"], a[href*="/products"], .button, [class*="button"], a[class*="btn"], a') ||
        hero.querySelector('h1, h2, [class*="headline"], [class*="title"]');
    }
    if (!anchor) return;
    var line = document.createElement('div');
    line.className = 'nv-hero-social';
    line.innerHTML = stars(5) + '<span>4,8/5 · valoraciones verificadas de clientas</span>';
    anchor.insertAdjacentElement('afterend', line);
  }

  function nvPriceText(main) {
    var el = main.querySelector('.price__current, sale-price, .price-item--regular, .price__regular, [class*="price__current"], .price [class*="price-item"], .price');
    if (!el) return '';
    var raw = (el.textContent || '').replace(/\s+/g, ' ').trim();
    var m = raw.match(/[\d.,]+\s?€|€\s?[\d.,]+/);
    return m ? m[0].trim() : raw.split(' ')[0];
  }
  function stickyATC(main) {
    if (window.innerWidth >= 750) return;
    if (document.querySelector('.nv-msab')) return;
    var atc = main.querySelector('[name="add"]');
    if (!atc) return;
    var h1 = main.querySelector('h1');
    var bar = document.createElement('div');
    bar.className = 'nv-msab';
    var nm = h1 ? h1.textContent.trim() : '';
    bar.innerHTML =
      '<div class="nv-msab__info"><div class="nv-msab__name">' + nm + '</div>' +
      '<div class="nv-msab__price">' + nvPriceText(main) + '</div></div>' +
      '<button type="button" class="nv-msab__btn">Añadir</button>';
    document.body.appendChild(bar);
    bar.querySelector('.nv-msab__btn').addEventListener('click', function () {
      if (atc.disabled) { atc.scrollIntoView({ behavior: 'smooth', block: 'center' }); return; }
      atc.click();
    });
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (es) {
        es.forEach(function (e) {
          if (e.isIntersecting) bar.classList.remove('is-on');
          else bar.classList.add('is-on');
        });
      }, { threshold: 0 });
      io.observe(atc);
    }
    function sync() {
      var p = bar.querySelector('.nv-msab__price'); if (p) p.textContent = nvPriceText(main);
      var b = bar.querySelector('.nv-msab__btn');
      if (b) b.textContent = atc.disabled ? 'Agotado' : 'Añadir';
    }
    document.addEventListener('variant:update', sync);
    document.addEventListener('change', function (e) { if (e.target.closest && e.target.closest('variant-picker, .variant-picker')) setTimeout(sync, 60); }, true);
  }

  function cartUpsell() {
    var drawer = document.querySelector('cart-drawer-component');
    if (!drawer || drawer.dataset.nvUps || drawer.querySelector('.nv-ups')) return;
    fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
      if (!cart || !cart.items || !cart.items.length) return;
      if (drawer.dataset.nvUps || drawer.querySelector('.nv-ups')) return;
      drawer.dataset.nvUps = '1';
      var pid = cart.items[0].product_id;
      var inCart = {}; cart.items.forEach(function (i) { inCart[i.product_id] = 1; });
      function getRecs(intent) {
        return fetch('/recommendations/products.json?product_id=' + pid + '&intent=' + intent + '&limit=8')
          .then(function (r) { return r.json(); })
          .then(function (d) { return ((d && d.products) ? d.products : []).filter(function (p) { return !inCart[p.id]; }); });
      }
      getRecs('complementary').then(function (recs) {
        if (recs.length >= 2) return recs;
        return getRecs('related');
      }).then(function (all) {
        var recs = all.slice(0, 2);
        if (recs.length < 2) { drawer.removeAttribute('data-nv-ups'); return; }
        if (drawer.querySelector('.nv-ups')) return;
        var cards = recs.map(function (p) {
          var img = p.featured_image || (p.images && p.images[0]) || '';
          var price = (p.price / 100).toFixed(2).replace('.', ',');
          return '<a class="nv-ups__card" href="' + p.url + '"><img loading="lazy" src="' + img + '" alt=""><div class="nv-ups__t">' + p.title + '</div><div class="nv-ups__p">€' + price + '</div></a>';
        }).join('');
        var box = document.createElement('div');
        box.className = 'nv-ups';
        box.innerHTML = '<p class="nv-ups__h">Quizás te guste</p><div class="nv-ups__row">' + cards + '</div>';
        // Place upsell AFTER the checkout buttons so payment options are seen first (no scroll past upsell).
        var anchor = drawer.querySelector('.cart-drawer__footer, [class*="cart-drawer__footer"], .cart__ctas');
        if (anchor) anchor.insertAdjacentElement('afterend', box);
        else drawer.appendChild(box);
      }).catch(function () { drawer.removeAttribute('data-nv-ups'); });
    }).catch(function () {});
  }

  function pdpCrossSell(main) {
    if (main.dataset.nvClook || main.querySelector('.nv-clook')) return;
    var m = location.pathname.match(/\/products\/([^/?#]+)/);
    if (!m) return;
    main.dataset.nvClook = '1';
    fetch('/products/' + m[1] + '.js').then(function (r) { return r.json(); }).then(function (prod) {
      var pid = prod.id;
      function getRecs(intent) {
        return fetch('/recommendations/products.json?product_id=' + pid + '&intent=' + intent + '&limit=8')
          .then(function (r) { return r.json(); })
          .then(function (d) { return ((d && d.products) ? d.products : []).filter(function (p) { return p.id !== pid; }); });
      }
      getRecs('complementary').then(function (recs) {
        if (recs.length >= 4) return recs;
        return getRecs('related');
      }).then(function (all) {
        var recs = all.slice(0, 4);
        if (recs.length < 2) { main.removeAttribute('data-nv-clook'); return; }
        if (main.querySelector('.nv-clook')) return;
        var cards = recs.map(function (p) {
          var img = p.featured_image || (p.images && p.images[0]) || '';
          var price = (p.price / 100).toFixed(2).replace('.', ',');
          return '<a class="nv-clook__card" href="' + p.url + '"><img loading="lazy" src="' + img + '" alt=""><div class="nv-clook__t">' + p.title + '</div><div class="nv-clook__p">€' + price + '</div></a>';
        }).join('');
        var sec = document.createElement('div');
        sec.className = 'nv-clook';
        sec.innerHTML = '<h2 class="nv-clook__h">Completa el look</h2><p class="nv-clook__hint">Combina 2 o más piezas y ahorra un <strong>10%</strong> automáticamente.</p><p class="nv-clook__sub">Seleccionado para combinar con esta pieza</p><div class="nv-clook__row">' + cards + '</div>';
        var anchor = main.querySelector('#nv-reviews') || main.querySelector('.nv-guarantee') || main.querySelector('details');
        if (anchor) anchor.insertAdjacentElement('afterend', sec);
        else main.appendChild(sec);
      }).catch(function () { main.removeAttribute('data-nv-clook'); });
    }).catch(function () { main.removeAttribute('data-nv-clook'); });
  }

  function homeFAQ() {
    var main = document.querySelector('main[data-template^="index"]');
    if (!main || document.querySelector('.nv-faq')) return;
    var footer = document.querySelector('footer');
    if (!footer) return;
    var QA = [
      ['¿Hacéis envíos a toda España?', 'Sí. Envío premium <strong>gratuito</strong> a toda España, con número de seguimiento incluido por email en cuanto procesamos tu pedido.'],
      ['¿Cómo son los cambios y devoluciones?', 'Tienes <strong>30 días</strong> para solicitar un cambio o devolución desde tu cuenta. Reembolso al método de pago original una vez recibida la prenda.'],
      ['¿Cómo acierto con la talla?', 'Cada producto incluye su <strong>guía de tallas europea</strong>. Si dudas entre dos, te recomendamos la mayor para un ajuste más holgado. Escríbenos y te asesoramos sin compromiso.'],
      ['¿El pago es seguro?', 'Totalmente. Pago <strong>100% cifrado</strong> y aceptamos Visa, Mastercard, Apple Pay, Shop Pay y Bizum.'],
      ['¿Qué calidad tienen las prendas?', 'Trabajamos con <strong>tejidos premium</strong> seleccionados por su caída y tacto. Cada pieza se revisa antes de enviarse.'],
      ['¿Puedo seguir mi pedido?', 'Sí. Recibes un <strong>número de seguimiento</strong> por email para rastrear tu paquete en todo momento.']
    ];
    var items = QA.map(function (x) {
      return '<div class="nv-faq__item"><button type="button" class="nv-faq__q">' + x[0] + '</button><div class="nv-faq__a"><p>' + x[1] + '</p></div></div>';
    }).join('');
    var sec = document.createElement('section');
    sec.className = 'nv-faq';
    sec.innerHTML = '<p class="nv-faq__eyebrow">Antes de comprar</p><h2 class="nv-faq__title">Preguntas frecuentes</h2>' + items;
    footer.insertAdjacentElement('beforebegin', sec);
    sec.addEventListener('click', function (e) {
      var q = e.target.closest('.nv-faq__q');
      if (!q) return;
      var item = q.parentElement;
      var a = item.querySelector('.nv-faq__a');
      var open = item.classList.toggle('is-open');
      a.style.maxHeight = open ? a.scrollHeight + 'px' : '0';
    });
  }

  function homeLookbook() {
    var main = document.querySelector('main[data-template^="index"]');
    if (!main || document.querySelector('.nv-look')) return;
    var footer = document.querySelector('footer');
    if (!footer) return;
    fetch('/products.json?limit=16').then(function (r) { return r.json(); }).then(function (d) {
      var prods = (d.products || []).filter(function (p) { return p.images && p.images.length; }).slice(0, 8);
      if (prods.length < 4) return;
      if (document.querySelector('.nv-look')) return;
      var cells = prods.map(function (p) {
        var img = p.images[0].src;
        return '<a class="nv-look__cell" href="/products/' + p.handle + '" aria-label="' + (p.title || '').replace(/"/g, '') + '"><img loading="lazy" src="' + img + '" alt=""><span class="nv-look__tag">Ver</span></a>';
      }).join('');
      var sec = document.createElement('section');
      sec.className = 'nv-look';
      sec.innerHTML = '<div class="nv-look__head"><p class="nv-look__eyebrow">@novalisestudio</p>' +
        '<h2 class="nv-look__title">El estilo NOVALISE</h2>' +
        '<p class="nv-look__sub">Inspiración para combinar tus piezas favoritas. Síguenos en @novalisestudio.</p></div>' +
        '<div class="nv-look__grid">' + cells + '</div>';
      footer.insertAdjacentElement('beforebegin', sec);
    }).catch(function () {});
  }

  function pdpTrustBadges(main) {
    if (main.dataset.nvTb || main.querySelector('.nv-tb')) return;
    var atc = main.querySelector('[name="add"]');
    if (!atc) return;
    var anchor = atc.closest('.product-form__buttons, buy-buttons-component, .buy-buttons, form') || atc.parentElement;
    if (!anchor) return;
    main.dataset.nvTb = '1';
    var ship = '<svg class="nv-tb__ic" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6"><path d="M3 7h11v8H3zM14 10h4l3 3v2h-7z"/><circle cx="7" cy="17" r="1.6"/><circle cx="17.5" cy="17" r="1.6"/></svg>';
    var ret = '<svg class="nv-tb__ic" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6"><path d="M3 12a9 9 0 1 0 3-6.7"/><path d="M3 4v4h4"/></svg>';
    var sec = '<svg class="nv-tb__ic" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6"><rect x="5" y="11" width="14" height="9" rx="1.5"/><path d="M8 11V8a4 4 0 0 1 8 0v3"/></svg>';
    var row = document.createElement('div');
    row.className = 'nv-tb';
    row.innerHTML =
      '<div class="nv-tb__item">' + ship + '<span class="nv-tb__t">Envío gratis España</span></div>' +
      '<div class="nv-tb__item">' + ret + '<span class="nv-tb__t">Garantía 30 días</span></div>' +
      '<div class="nv-tb__item">' + sec + '<span class="nv-tb__t">Pago seguro</span></div>';
    anchor.insertAdjacentElement('afterend', row);
  }

  function pdpPriceClean(main) {
    var atc = main.querySelector('[name="add"]');
    var scope = null;
    if (atc) {
      var info = atc.closest('product-form-component, .product-form, .product-information, [class*="product-information"], [class*="product__info"], form') || main;
      scope = info.querySelector('[class*="price"]') || main.querySelector('[class*="price"]');
    } else {
      scope = main.querySelector('[class*="price"]');
    }
    if (!scope) return;
    var priceRoot = scope.closest('.price, [class*="price__container"], [class*="price-block"]') || scope;
    if (priceRoot.closest('cart-drawer-component, [class*="cart-items"], [class*="cart-drawer"], [class*="nv-"]')) return;
    var nvProdCache = null;
    var nvBusy = false;
    function applyClean(prod) {
      if (!prod || !prod.variants || !prod.variants.length) return;
      var v = null, vid = null;
      var qp = location.search.match(/[?&]variant=(\d+)/);
      if (qp) vid = parseInt(qp[1], 10);
      if (!vid) {
        var vsel = main.querySelector('[name="id"]');
        if (vsel && vsel.value) vid = parseInt(vsel.value, 10);
      }
      if (vid) { for (var i = 0; i < prod.variants.length; i++) { if (prod.variants[i].id === vid) { v = prod.variants[i]; break; } } }
      if (!v) v = prod.variants[0];
      var price = v.price;
      var cmp = v.compare_at_price;
      var hasRealDiscount = !!(cmp && cmp > price);
      if (hasRealDiscount) return;
      nvBusy = true;
      var all = priceRoot.querySelectorAll('*');
      for (var j = 0; j < all.length; j++) {
        var node = all[j];
        if (node.classList && node.classList.contains('nv-price-clean')) continue;
        var ownText = '';
        for (var k = 0; k < node.childNodes.length; k++) {
          if (node.childNodes[k].nodeType === 3) ownText += node.childNodes[k].nodeValue;
        }
        ownText = ownText.replace(/\s+/g, ' ').trim();
        if (ownText === 'Ahora' || /^precio habitual$/i.test(ownText)) {
          node.classList.add('nv-price-clean');
        }
      }
      var saleGroup = priceRoot.querySelector('.price__sale, .price-item__group--sale, [class*="price__sale"]');
      var regularGroup = priceRoot.querySelector('.price__regular, .price-item__group--regular, [class*="price__regular"]');
      function amt(el) { if (!el) return ''; var mm = (el.textContent || '').match(/[\d.,]+\s?€|€\s?[\d.,]+/); return mm ? mm[0].replace(/\s+/g, '') : ''; }
      if (saleGroup && regularGroup && saleGroup !== regularGroup &&
          !saleGroup.classList.contains('nv-price-clean') && !regularGroup.classList.contains('nv-price-clean')) {
        var a1 = amt(saleGroup), a2 = amt(regularGroup);
        if (a1 && a2 && a1 === a2) {
          saleGroup.classList.add('nv-price-clean');
        }
      }
      setTimeout(function () { nvBusy = false; }, 0);
    }
    function clean() {
      var m = location.pathname.match(/\/products\/([^/?#]+)/);
      if (!m) return;
      if (nvProdCache) { applyClean(nvProdCache); return; }
      fetch('/products/' + m[1] + '.js').then(function (r) { return r.json(); }).then(function (prod) {
        nvProdCache = prod;
        applyClean(prod);
      }).catch(function () {});
    }
    if (!main.dataset.nvPriceClean) {
      main.dataset.nvPriceClean = '1';
      clean();
      document.addEventListener('variant:update', clean);
      document.addEventListener('variant:change', clean);
      document.addEventListener('cart:update', clean);
      if ('MutationObserver' in window) {
        var pmo = new MutationObserver(function () { if (nvBusy) return; clean(); });
        pmo.observe(priceRoot, { childList: true, subtree: true, characterData: true });
      }
    }
  }

  // ===== OFERTAS: storefront contextual pricing drops compare_at (Markets quirk); inject the
  // strikethrough "antes" price + % badge visually for the curated promo products. Checkout price
  // is unchanged — this is an anchor-price display layer only. Keyed by unique handle fragments. =====
  var NV_SALE = {
    'nv-jacqueline-vestido-de-verano': 13400,
    'vestido-hallie-largo-verde-esmeralda': 15900,
    'jerelin-ethereal-satin-cascade': 17900,
    'peggy-maxi-dress-blush': 17900,
    'solenne-jewel-tone-pleated': 17900,
    'selena-sculpted-draped-dress': 8900,
    'sleeveless-wide-leg-jumpsuit-for-summer-breezes': 8900,
    'arianny-polished-two-piece-set': 14900,
    'elizabeth-high-neck-embroidered-zip-jumpsuit': 14900,
    'levila-premium-comfort-sandals': 17900,
    'alina-your-sculpting-bikini': 11900,
    'marvella-tailored-flow-pants': 11900,
    'borsa-in-pelliccia': 19700,
    'lunara-woven-straw-tote-bag': 17900,
    'flora-vestido-coral-bloom': 13400
  };
  function nvSaleFor(h) { if (!h) return 0; h = h.toLowerCase(); for (var k in NV_SALE) { if (h.indexOf(k) >= 0) return NV_SALE[k]; } return 0; }
  function nvMoney(c) { return '€' + (c / 100).toFixed(2).replace('.', ','); }
  function nvCurrentCents(scope) {
    var pe = scope.querySelector('.price-item--sale, .price__regular .price, .price-item--regular .price, .price');
    var t = pe ? (pe.textContent || '') : '';
    var m = t.match(/([\d]{1,3}(?:[.\s]?\d{3})*(?:,\d{2})?)/);
    if (!m) return 0;
    return Math.round(parseFloat(m[1].replace(/[.\s]/g, '').replace(',', '.')) * 100);
  }
  function nvWasEl(cents, cur, badge) {
    var wrap = document.createElement('span'); wrap.className = 'nv-salewrap';
    var s = document.createElement('span'); s.className = 'nv-was'; s.textContent = nvMoney(cents); wrap.appendChild(s);
    if (badge && cur && cur < cents) {
      var off = Math.round((1 - cur / cents) * 100);
      if (off > 0) { var b = document.createElement('span'); b.className = 'nv-off'; b.textContent = '−' + off + '%'; wrap.appendChild(b); }
    }
    return wrap;
  }
  function nvSalePDP() {
    var m = location.pathname.match(/\/products\/([^/?#]+)/); if (!m) return;
    var cents = nvSaleFor(decodeURIComponent(m[1])); if (!cents) return;
    var main = document.querySelector('main[data-template^="product"]') || document;
    var cont = main.querySelector('product-price [ref="priceContainer"]') || main.querySelector('product-price') || main.querySelector('.price');
    if (!cont || cont.querySelector('.nv-was')) return;
    var cur = nvCurrentCents(cont);
    var reg = cont.querySelector('.price__regular') || cont;
    reg.appendChild(nvWasEl(cents, cur, true));
  }
  function nvSaleCards(scope) {
    var links = (scope || document).querySelectorAll('a[href*="/products/"]');
    for (var i = 0; i < links.length; i++) {
      var a = links[i];
      var hm = (a.getAttribute('href') || '').match(/\/products\/([^/?#]+)/); if (!hm) continue;
      var cents = nvSaleFor(decodeURIComponent(hm[1])); if (!cents) continue;
      var card = a.closest('.product-card, .card-product, product-card, [class*="product-card"], .card, li.grid__item, .product-grid__item') || a.parentElement;
      if (!card || card.querySelector('.nv-was')) continue;
      if (card.closest('cart-drawer-component, .nv-ups, .nv-clook')) continue;
      var pe = card.querySelector('[class*="price"]'); if (!pe) continue;
      var cur = nvCurrentCents(card);
      pe.appendChild(nvWasEl(cents, cur, false));
    }
  }
  function nvSaleRun() { try { nvSalePDP(); nvSaleCards(document); } catch (e) {} }

  function run() {
    injectStyles();
    fixCartCopy();
    injectShipping();
    nvQtyNudge();
    cartTrust();
    cartUpsell();
    var pmain = document.querySelector('main[data-template^="product"]');
    if (pmain) { pdpReviews(pmain); pdpScarcity(pmain); nvColorSwatches(pmain); pdpTrustBadges(pmain); pdpQtyHint(pmain); pdpPriceClean(pmain); pdpETA(pmain); stickyATC(pmain); pdpCrossSell(pmain); }
    nvHeroOffer();
    nvHeroSocial();
    homeLookbook();
    homeTestimonials();
    homeFAQ();
    collectionCards();
    welcomePopup();
    /* nvSaleRun() removed — compare-at now shows NATIVELY via the ES market price list */
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();
  var mo = new MutationObserver(function () { fixCartCopy(); injectShipping(); nvQtyNudge(); cartTrust(); cartUpsell(); collectionCards(); });
  mo.observe(document.body, { childList: true, subtree: true });
  document.addEventListener('cart:update', function () { fixCartCopy(); injectShipping(); nvQtyNudge(); cartTrust(); cartUpsell(); });

  var nvAddClicked = 0;
  document.addEventListener('click', function (e) {
    var t = e.target.closest && e.target.closest('[name="add"], [class*="add-to-cart"] button, button[name="add"], product-form button[type="submit"]');
    if (t) nvAddClicked = Date.now();
  }, true);
  function nvOpenDrawer() {
    if (location.pathname.indexOf('/cart') === 0 || location.pathname.indexOf('/checkout') === 0) return;
    if (document.querySelector('cart-drawer-component dialog[open]')) return;
    var toggle = null, btns = document.querySelectorAll('button[aria-label], a[aria-label]');
    for (var i = 0; i < btns.length; i++) { if (/cesta|cart|carrito|bag/i.test(btns[i].getAttribute('aria-label') || '')) { toggle = btns[i]; break; } }
    if (!toggle) { var d = document.querySelector('cart-drawer-component'); if (d && typeof d.open === 'function') { try { d.open(); } catch (e) {} } return; }
    toggle.click();
  }
  document.addEventListener('cart:update', function () {
    if (Date.now() - nvAddClicked < 5000) setTimeout(nvOpenDrawer, 180);
  });
  setTimeout(run, 600);
})();
